// MapLibre v6 locates its GL worker with `new URL("./maplibre-gl-worker.mjs", import.meta.url)`.
// Vite's dep optimizer rewrites that to `.vite/deps/maplibre-gl-worker.mjs` and never emits the
// file, which 404s and blanks the inventory map. `?worker&url` runs the worker through Vite's
// worker pipeline so the sibling `maplibre-gl-shared.mjs` import is bundled too (MapLibre Vite 7
// recipe; ADR-018). Call before any Map mounts.
import { setWorkerUrl } from "maplibre-gl";
import workerUrl from "maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url";

setWorkerUrl(workerUrl);
